module.exports = __webpack_public_path__ + "static/media/dev-expectations-mobile.e446108e.png";